import ModernOpportunitiesDevelopment from '../components/ModernOpportunitiesDevelopment';

// /opportunities/develop — one expanded "My Opportunities" ledger for every
// brand (s153): the «Moderno» page approved in s141, skinned per theme
// (lib/opportunitySkin).
export default function OpportunitiesDevelopmentPage() {
  return <ModernOpportunitiesDevelopment />;
}
